import React from 'react';
import { Box, Flex, Icon, Text, VStack } from '@chakra-ui/react';
import { FiCheck } from 'react-icons/fi';
import { Navigate, useNavigate } from 'react-router-dom';
import { useGetKycSummaryQuery } from '../../api';
import { IS_KYC_ENABLED } from '../../api/utils';
import { useTranslation } from '../../hooks/useTranslation';
import Button from '../../components/base/Button';
import PageTitle from '../../components/base/PageTitle';
import { KYC_ROUTE } from './kycRoutes';

const KycSuccessPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const query = useGetKycSummaryQuery(undefined, {
        skip: !IS_KYC_ENABLED,
        refetchOnMountOrArgChange: true,
    });
    if (!IS_KYC_ENABLED) return <Navigate to="/profile" replace />;
    if (!query.isFetching && !query.isError && query.data && !query.data.is_completed)
        return <Navigate to={KYC_ROUTE} replace />;
    return (
        <Flex flex={1} minH={0} direction="column" overflow="auto" bg="gray.100" px={4}>
            <PageTitle title={t.kyc.title} />
            <VStack gap={5} bg="white" p={6} w={{ base: 'full', md: '600px' }} mx="auto" mb="100px">
                {query.isFetching ? (
                    <Text role="status">{t.kyc.loading}</Text>
                ) : query.isError ? (
                    <Box role="alert">
                        <Text>{t.kyc.errors.load}</Text>
                        <Button buttonType="secondary" onClick={() => void query.refetch()}>
                            {t.kyc.retry}
                        </Button>
                    </Box>
                ) : query.data?.is_completed ? (
                    <>
                        <Icon as={FiCheck} boxSize={12} color="green.600" />
                        <Text fontSize="2xl" fontWeight="bold" textAlign="center">
                            {t.kyc.successTitle}
                        </Text>
                        <Text textAlign="center" color="gray.600">
                            {t.kyc.successDescription}
                        </Text>
                        <Button buttonType="success" w="full" onClick={() => navigate('/mail')}>
                            {t.kyc.done}
                        </Button>
                    </>
                ) : null}
            </VStack>
        </Flex>
    );
};
export default KycSuccessPage;
